import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description: 'We’re legally required to ask you for a proof of address',
    editAddress: 'Edit',
    subTitleCheckAddress: 'Check your personal address',
    title: 'Proof of address',
  },
  fr: {
    description:
      'La réglementation bancaire nous impose de vous demander un justificatif de domicile.',
    editAddress: 'Modifier',
    subTitleCheckAddress: 'Vérifiez votre adresse personnelle',
    title: 'Justificatif de domicile',
  },
});
